var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNurture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 503.6 164.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 173.92,
    y1: 142.66,
    x2: -25.02,
    y2: 60.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e63551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29378c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-2",
    x1: 28.05,
    y1: -26.73,
    x2: 192.29,
    y2: 137.28,
    xlinkHref: "#GradientFill_1"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ln-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "109.87 109.87 54.93 109.87 54.93 54.94 0 0 0 54.94 0 109.87 54.93 164.81 109.87 164.81 109.87 109.87",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,109.87H54.93v54.94h0A54.94,54.94,0,0,1,0,109.87Z",
    style: {
      fill: "#803a85",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.81 164.81 109.87 109.87 109.87 54.94 54.93 54.94 0 0 109.87 0 164.81 54.94 164.81 54.94 164.81 109.87 164.81 164.81",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,54.94H109.87V0h0A54.94,54.94,0,0,1,164.81,54.94Z",
    style: {
      fill: "#4d398e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.49 0 369.16 0 316.56 0 316.56 53.7 316.56 54.93 371.49 0",
    style: {
      fill: "#2d4999",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.85,90V49.5h-14.4v52.68h28.8V90Zm56.47.14a27.14,27.14,0,0,1-11.94,2.39c-6.46,0-10.61-2.25-11.8-7h26.06a19.5,19.5,0,0,0,.35-4.08,18.39,18.39,0,0,0-19-19,18.82,18.82,0,0,0-14.25,6A19.85,19.85,0,0,0,240,82.8a19.48,19.48,0,0,0,6.11,14.82q6.21,5.68,16.43,5.69c5.06,0,10.47-.85,13.91-2.74l-.14-10.4ZM260.09,73c4,0,7,2.53,7.17,6.47H252.37A7.64,7.64,0,0,1,260.09,73Zm49.24,17.63a8,8,0,0,1-3.16.56c-2.74,0-4.15-1.61-4.15-4.35V74.65h7.31v-11H302V53.16H288.4V63.62h-4.92v11h4.92V87.5c0,9.84,5.62,15.81,14.89,15.81a14.25,14.25,0,0,0,6-1.2V90.66Zm18.33,12.65q8.11,0,12.85-3.8c3.16-2.53,4.78-5.55,4.78-9.06,0-5.34-2.74-8.43-8.71-10.74l-3.44-1.41c-2-.84-2.95-1.61-2.95-2.81,0-1.68,2-2.88,5.48-2.88a14.32,14.32,0,0,1,7.3,1.9V64.11a23.12,23.12,0,0,0-9-1.61c-5.41,0-9.76,1.19-13,3.58s-4.85,5.2-4.85,8.64c0,5,3.09,8,8.64,10.18l3.72,1.48c2.46.91,3.3,1.89,3.3,3.3,0,1.61-1.75,3.3-6,3.3-3.72,0-7.65-1.33-9.55-3V100.5C318.25,102,322.6,103.31,327.66,103.31Z",
    style: {
      fill: "#1a1a18",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.89,111v26.77l-34.2-27.26h-1.34v53.17H220.4V136.92l34.28,27.32h1.26V111ZM288,164.81c12.85,0,20.37-7.38,20.37-19.39v-20.3H294.5v21.36c0,4.28-2,7.16-6.46,7.16-4.21,0-6.25-2.88-6.25-7.16V125.12h-14v20.3c0,6,1.76,10.75,5.34,14.19s8.57,5.2,14.89,5.2Zm45-19.11c0-5.9,3.8-8.85,8.78-8.85a11.19,11.19,0,0,1,4.57,1V124.49a13.06,13.06,0,0,0-3.58-.49c-5.34,0-9.91,3.44-11.59,9.62v-8.5H318.87v38.56h14.19v-18ZM375,152.16a7.94,7.94,0,0,1-3.16.57c-2.74,0-4.14-1.62-4.14-4.36V136.15H375v-11h-7.3V114.66H354.06v10.46h-4.91v11h4.91V149c0,9.84,5.62,15.81,14.89,15.81a14.25,14.25,0,0,0,6-1.2V152.16Zm27.82,12.65c12.85,0,20.37-7.38,20.37-19.39v-20.3H409.27v21.36c0,4.28-2,7.16-6.46,7.16-4.22,0-6.25-2.88-6.25-7.16V125.12h-14v20.3c0,6,1.76,10.75,5.34,14.19s8.57,5.2,14.89,5.2Zm45-19.11c0-5.9,3.79-8.85,8.78-8.85a11.19,11.19,0,0,1,4.57,1V124.49a13.08,13.08,0,0,0-3.59-.49c-5.33,0-9.9,3.44-11.59,9.62v-8.5H433.64v38.56h14.19v-18Zm53.1,6A27.14,27.14,0,0,1,489,154.06c-6.46,0-10.61-2.25-11.8-6.95h26.06a19.5,19.5,0,0,0,.35-4.08,18.39,18.39,0,0,0-19-19,18.84,18.84,0,0,0-14.26,6,19.85,19.85,0,0,0-5.69,14.33,19.48,19.48,0,0,0,6.11,14.82q6.21,5.69,16.43,5.69c5.06,0,10.47-.85,13.91-2.74l-.14-10.4Zm-16.22-17.13c4,0,7,2.52,7.16,6.46H477A7.64,7.64,0,0,1,484.71,134.54Z",
    style: {
      fill: "#1a1a18",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurture);
export default __webpack_public_path__ + "static/media/nurture.618dc7ccdd082b23675cf0445414f27d.svg";
export { ForwardRef as ReactComponent };